module.exports = __webpack_public_path__ + "img/third-image.88fee74e.png";